export function SET_AUTHENTICATED_USER(state, user) {
  state.authenticatedUser = user;
}
export function SET_TOKEN(state, token) {
  state.token = token;
}
export function SET_ERROR(state, error) {
  state.error = error;
}
export function SET_USER_DATA(state, data) {
  state.token = data.TOKEN;
  state.authenticatedUser = data.USER;
  state.session = data.SESSION;
}
export function SET_LOG_OUT(state) {
  state.authenticatedUser = null;
  state.token = null;
  state.session = null;
  state.permissions = [];
}

export function SET_PERMISSIONS(state, userRoles) {
  let allPermissions = userRoles.map(role => role.permissions);
  let permissionsFiltered = [...new Set(allPermissions.flat())];

  state.permissions = permissionsFiltered;
}

export function SET_AUTHENTICATED_STATUS(state, status) {
  state.authenticated = status;
}

/**
 * Updates the application language and stores it in localStorage.
 * 
 * This function sets the selected language in the local storage for persistence
 * and updates the state with the new language to ensure reactivity within the application.
 * 
 * @param {Object} state - The Vuex or Pinia state object that holds the current application state.
 * @param {String} language - The language code to set (e.g., 'en', 'es', 'pt').
 */
export function SET_LANGUAGE(state, language) {
  localStorage.setItem("language", language);
  state.language = language;
}